// Auto-generated SEO landing-page content. Edit copy here; slugs are mirrored in backend/data/seoSlugs.json.
export const SEO_GROUPS = [["product", "Products & Services"], ["use", "By Occasion & Use"], ["method", "Printing Methods"], ["city", "Delivery Cities"]];

export const SEO_PAGES = [
 {
  "group": "product",
  "slug": "on-demand-tshirt-printing",
  "h1": "On-Demand T-Shirt Printing in India",
  "title": "On-Demand T-Shirt Printing India",
  "desc": "Order printed t-shirts on demand in India. No minimum order, no stock. Printed on 220 GSM cotton and delivered in 5–7 days. Design yours today.",
  "intro": "SNERA prints every t-shirt only after you order it. There is no stock to buy and no minimum quantity — your design is printed on 220 GSM heavyweight cotton and delivered across India.",
  "points": [
   "Printed only after you order — nothing sits in a warehouse",
   "One piece or a full batch, same quality",
   "Digital preview on WhatsApp before printing",
   "Dispatched within 24–48 hours of confirmation"
  ],
  "faqs": [
   [
    "What is on-demand t-shirt printing?",
    "Each t-shirt is printed after the order is placed instead of being made in advance. You pay only for what you need and your design is never mass-produced."
   ],
   [
    "Do I need to buy stock or reach a minimum quantity?",
    "No. You can order a single custom t-shirt or hundreds. Everything is printed to order."
   ]
  ],
  "related": [
   "custom-tshirt-printing",
   "single-piece-custom-tshirt",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "on demand t-shirt printing",
   "on demand printed t-shirts india",
   "print on demand t-shirts india",
   "on demand tshirt printing online",
   "printable t-shirt on demand"
  ]
 },
 {
  "group": "product",
  "slug": "custom-tshirt-printing",
  "h1": "Custom T-Shirt Printing Online in India",
  "title": "Custom T-Shirt Printing Online",
  "desc": "Design and order custom printed t-shirts online in India. Premium 220 GSM cotton, DTG and screen printing, free shipping above ₹999.",
  "intro": "Upload your artwork, describe your idea, or start from a concept in our Design Studio. We print it on pre-shrunk, bio-washed 220 GSM cotton and deliver anywhere in India.",
  "points": [
   "Front, back and sleeve prints",
   "Choose your colour and size",
   "DTG, screen print, puff print or embroidery",
   "Free shipping on orders above ₹999"
  ],
  "faqs": [
   [
    "How do I order a custom t-shirt?",
    "Describe your design in the Design Studio or message us on WhatsApp. We send a digital preview, you approve it, and we print and ship."
   ],
   [
    "What fabric do you use?",
    "All SNERA t-shirts use 220 GSM super-combed, pre-shrunk, bio-washed cotton."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "photo-tshirt-printing",
   "name-and-text-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing online",
   "custom printed t-shirts india",
   "design your own t-shirt",
   "personalised t-shirt printing",
   "customised t shirts online"
  ]
 },
 {
  "group": "product",
  "slug": "oversized-tshirt-printing",
  "h1": "Custom Oversized T-Shirt Printing",
  "title": "Custom Oversized T-Shirt Printing",
  "desc": "Print your design on a heavyweight oversized t-shirt. Boxy fit, 220 GSM cotton, no minimum order, delivered across India.",
  "intro": "The boxy oversized cut shows big back graphics and statement prints at their best. Ours is cut from 220 GSM cotton so it hangs properly instead of clinging.",
  "points": [
   "Boxy relaxed fit with a heavy drape",
   "Large front and back prints look sharper on the wider panel",
   "Heavyweight cotton that holds its shape after washing",
   "Order one or a group set"
  ],
  "faqs": [
   [
    "Should I size up for an oversized tee?",
    "Our oversized cut is already relaxed. Check the Size Guide and pick your usual size for the intended boxy look."
   ],
   [
    "Which print works best on oversized tees?",
    "Large chest, back and puff prints are the most popular because the wider panel gives them room."
   ]
  ],
  "related": [
   "drop-shoulder-tshirt-printing",
   "puff-print-tshirts",
   "custom-tshirt-printing"
  ],
  "keywords": [
   "custom oversized t-shirt",
   "oversized t-shirt printing india",
   "print on oversized tee",
   "oversized tee with custom design",
   "baggy t-shirt printing"
  ]
 },
 {
  "group": "product",
  "slug": "custom-hoodie-printing",
  "h1": "Custom Hoodie Printing in India",
  "title": "Custom Hoodie Printing Online",
  "desc": "Order custom printed hoodies online in India. Add your logo, text or artwork — one piece or bulk, delivered across India.",
  "intro": "A custom hoodie is the go-to for team, college and brand merch. Send your logo or idea and we will confirm the print placement with you before anything is printed.",
  "points": [
   "Chest logos, back prints and embroidery options",
   "Good for teams, clubs, colleges and brands",
   "Preview approved on WhatsApp before printing",
   "No minimum order"
  ],
  "faqs": [
   [
    "Can I add a logo to the chest and a design on the back?",
    "Yes. Tell us the placement and we will confirm a preview before printing."
   ],
   [
    "Do you do bulk hoodie orders?",
    "Yes. Message us with the quantity and sizes for a quote."
   ]
  ],
  "related": [
   "bulk-tshirt-printing",
   "corporate-team-tshirts",
   "embroidered-tshirts"
  ],
  "keywords": [
   "custom hoodie printing",
   "custom hoodies india",
   "personalised hoodie online",
   "printed hoodie with logo",
   "team hoodie printing"
  ]
 },
 {
  "group": "product",
  "slug": "polo-tshirt-printing",
  "h1": "Custom Polo T-Shirt Printing",
  "title": "Custom Polo T-Shirt Printing",
  "desc": "Custom polo t-shirts with your logo for teams, offices and events. Embroidery or print, no minimum order, delivered across India.",
  "intro": "Polo shirts with a small chest logo are the standard for office teams, staff and events. We can print or embroider your logo on the left chest.",
  "points": [
   "Left-chest logo placement",
   "Embroidery for a premium finish",
   "Matching sets for staff and teams",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Is embroidery available on polos?",
    "Yes. Embroidery on the left chest is one of our finishing options for logos."
   ],
   [
    "Can I get different sizes in one order?",
    "Yes. Share the sizes for each person when you order."
   ]
  ],
  "related": [
   "corporate-team-tshirts",
   "embroidered-tshirts",
   "startup-company-tshirts"
  ],
  "keywords": [
   "custom polo t-shirt",
   "polo t-shirt with logo",
   "company polo t-shirt printing",
   "embroidered polo shirt india",
   "corporate polo t-shirts"
  ]
 },
 {
  "group": "product",
  "slug": "custom-tank-top-printing",
  "h1": "Custom Tank Top Printing",
  "title": "Custom Tank Top Printing",
  "desc": "Print your design on custom tank tops for gyms, teams and summer wear. No minimum order, delivered across India.",
  "intro": "Tank tops are popular for gym crews, dance groups and beach trips. Add a name, number or graphic and we will print it to order.",
  "points": [
   "Gym, dance and sports group favourite",
   "Names and numbers printed per piece",
   "Order one or a full group set",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Can each tank top have a different name?",
    "Yes. Send us a list of names and sizes and we will print each one separately."
   ],
   [
    "Is there a minimum order?",
    "No. A single tank top is fine."
   ]
  ],
  "related": [
   "gym-and-fitness-tshirts",
   "group-tshirt-printing",
   "dtg-tshirt-printing"
  ],
  "keywords": [
   "custom tank top",
   "gym tank top printing",
   "personalised sleeveless t-shirt",
   "custom vest printing",
   "printed tank tops india"
  ]
 },
 {
  "group": "product",
  "slug": "drop-shoulder-tshirt-printing",
  "h1": "Drop Shoulder T-Shirt Printing",
  "title": "Drop Shoulder T-Shirt Printing",
  "desc": "Custom drop shoulder t-shirts printed to order in India. Relaxed street fit, 220 GSM cotton, no minimum order.",
  "intro": "The drop shoulder cut gives a laid-back, streetwear silhouette. It suits graphics, typography and minimal prints printed to order.",
  "points": [
   "Dropped seam for a relaxed streetwear fit",
   "Premium 220 GSM cotton",
   "Front, back and sleeve prints",
   "No minimum order"
  ],
  "faqs": [
   [
    "How is a drop shoulder different from oversized?",
    "A drop shoulder has a lowered shoulder seam and a boxy body. Our oversized tee adds extra overall volume. Both are relaxed fits."
   ],
   [
    "Can I print on the back?",
    "Yes. Front, back and sleeve prints are all available."
   ]
  ],
  "related": [
   "oversized-tshirt-printing",
   "custom-tshirt-printing",
   "puff-print-tshirts"
  ],
  "keywords": [
   "drop shoulder t-shirt printing",
   "custom drop shoulder tee",
   "streetwear t-shirt printing india",
   "drop shoulder tee with design",
   "print on drop shoulder t-shirt"
  ]
 },
 {
  "group": "product",
  "slug": "photo-tshirt-printing",
  "h1": "Photo T-Shirt Printing — Print Your Picture",
  "title": "Photo T-Shirt Printing India",
  "desc": "Print your photo on a t-shirt. Family, pet and couple photo tees printed on 220 GSM cotton and delivered across India.",
  "intro": "Turn a favourite photo into a wearable gift. We use full-colour DTG printing, which handles photographs and detailed images well.",
  "points": [
   "Full-colour DTG printing for photos",
   "Great for couples, families and pets",
   "Use a high-resolution image for the best result",
   "Preview shared before printing"
  ],
  "faqs": [
   [
    "What kind of photo works best?",
    "A sharp, well-lit, high-resolution image. If your photo is low quality, tell us and we will advise before printing."
   ],
   [
    "Can I print more than one photo?",
    "Yes. Collage layouts are possible; share the images and we will send a preview."
   ]
  ],
  "related": [
   "dtg-tshirt-printing",
   "couple-tshirt-printing",
   "family-matching-tshirts"
  ],
  "keywords": [
   "photo t-shirt printing",
   "print my photo on t-shirt",
   "custom photo t-shirt india",
   "personalised photo tee",
   "picture printed t-shirt"
  ]
 },
 {
  "group": "product",
  "slug": "name-and-text-tshirt-printing",
  "h1": "Name & Text T-Shirt Printing",
  "title": "Name & Text T-Shirt Printing",
  "desc": "Print names, quotes and slogans on t-shirts. Typography designs on 220 GSM cotton, no minimum order, delivered across India.",
  "intro": "A name, quote or slogan can be the whole design. We set the typography and send a preview so you can approve the font, colour and placement first.",
  "points": [
   "Names, quotes, slogans and numbers",
   "Screen print for crisp, bold lettering",
   "Preview of font and placement before printing",
   "Single piece or group"
  ],
  "faqs": [
   [
    "Can I choose the font and colour?",
    "Yes. Tell us your preference or describe the feel and we will suggest options in the preview."
   ],
   [
    "Can every shirt carry a different name?",
    "Yes. Share a list of names and sizes in your order message."
   ]
  ],
  "related": [
   "custom-tshirt-printing",
   "screen-printing-tshirts",
   "group-tshirt-printing"
  ],
  "keywords": [
   "name printed t-shirt",
   "custom text t-shirt",
   "quote t-shirt printing",
   "personalised name t-shirt",
   "slogan t-shirt printing india"
  ]
 },
 {
  "group": "product",
  "slug": "custom-mug-printing",
  "h1": "Custom Mug Printing in India",
  "title": "Custom Mug Printing Online",
  "desc": "Order custom printed mugs with your photo, name or design. Personalised gifts delivered across India.",
  "intro": "A printed mug is a simple, personal gift. Add a photo, name or design and we will confirm a preview before printing.",
  "points": [
   "Photos, names and designs",
   "Good for birthdays, anniversaries and corporate gifts",
   "Preview before printing",
   "Delivered across India"
  ],
  "faqs": [
   [
    "Can I print a photo on a mug?",
    "Yes. Send a clear, high-resolution photo and we will share a preview."
   ],
   [
    "Do you do bulk mug orders for gifting?",
    "Yes. Message us with the quantity for a quote."
   ]
  ],
  "related": [
   "birthday-tshirt-printing",
   "corporate-team-tshirts",
   "custom-keychain-printing"
  ],
  "keywords": [
   "custom mug printing",
   "personalised mug india",
   "photo mug printing",
   "name mug online",
   "printed coffee mug gift"
  ]
 },
 {
  "group": "product",
  "slug": "custom-keychain-printing",
  "h1": "Custom Keychain Printing",
  "title": "Custom Keychain Printing India",
  "desc": "Personalised keychains with your photo, name or logo. Ideal return gifts and promotional items, delivered across India.",
  "intro": "Keychains are inexpensive, useful and easy to hand out — popular as return gifts, event favours and promotional items.",
  "points": [
   "Name, logo or photo keychains",
   "Popular for return gifts and events",
   "Order small or large quantities",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Can I add my company logo?",
    "Yes. Send the logo file and we will confirm the layout in a preview."
   ],
   [
    "Do you make keychains in bulk?",
    "Yes. Share the quantity and we will quote."
   ]
  ],
  "related": [
   "event-and-festival-tshirts",
   "corporate-team-tshirts",
   "custom-mug-printing"
  ],
  "keywords": [
   "custom keychain printing",
   "personalised keychain india",
   "photo keychain",
   "logo keychain bulk",
   "return gift keychain"
  ]
 },
 {
  "group": "product",
  "slug": "custom-phone-case-printing",
  "h1": "Custom Phone Case Printing",
  "title": "Custom Phone Case Printing",
  "desc": "Print your photo or design on a phone case. Personalised mobile covers delivered across India.",
  "intro": "Put your own photo or artwork on your phone case. Tell us your phone model and share the image, and we will send a preview.",
  "points": [
   "Your photo, artwork or name",
   "Tell us the phone model when ordering",
   "Good for gifts",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Which phone models are supported?",
    "Share your exact model when you order and we will confirm availability."
   ],
   [
    "Can I use my own photo?",
    "Yes. A high-resolution image gives the best print."
   ]
  ],
  "related": [
   "photo-tshirt-printing",
   "couple-tshirt-printing",
   "birthday-tshirt-printing"
  ],
  "keywords": [
   "custom phone case printing",
   "personalised phone cover india",
   "photo phone case",
   "name phone case online",
   "custom mobile cover"
  ]
 },
 {
  "group": "product",
  "slug": "custom-tote-bag-printing",
  "h1": "Custom Tote Bag Printing",
  "title": "Custom Tote Bag Printing India",
  "desc": "Printed tote bags for brands, events and gifting. Add your logo or artwork, order one or in bulk, delivered across India.",
  "intro": "Tote bags are an everyday, reusable way to carry your brand or message. Add your logo or artwork and we print to order.",
  "points": [
   "Logos, quotes and artwork",
   "Popular for events, brands and shops",
   "Single piece or bulk",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Can I order tote bags for an event?",
    "Yes. Share the quantity and date and we will confirm timelines."
   ],
   [
    "Can I print on both sides?",
    "Tell us your design and we will confirm placement options in the preview."
   ]
  ],
  "related": [
   "event-and-festival-tshirts",
   "startup-company-tshirts",
   "custom-mug-printing"
  ],
  "keywords": [
   "custom tote bag printing",
   "printed tote bags india",
   "logo tote bag",
   "personalised canvas bag",
   "promotional tote bags"
  ]
 },
 {
  "group": "use",
  "slug": "group-tshirt-printing",
  "h1": "Group T-Shirt Printing for Teams & Friends",
  "title": "Group T-Shirt Printing India",
  "desc": "Matching custom t-shirts for your group, team or gang. One design, many sizes — printed to order and delivered across India.",
  "intro": "Matching tees make any group feel like a team. Share one design and the sizes and names for each person and we will handle the rest.",
  "points": [
   "One design, mixed sizes in a single order",
   "Optional name or number per person",
   "Preview approved before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "How do I order for a group?",
    "Message us with the design idea, quantity and sizes, or list them in the order notes. We confirm a preview and a price."
   ],
   [
    "Can each person have a different name?",
    "Yes. Send the list of names and sizes."
   ]
  ],
  "related": [
   "bulk-tshirt-printing",
   "trip-and-travel-group-tshirts",
   "college-fest-tshirts"
  ],
  "keywords": [
   "group t-shirt printing",
   "matching group t-shirts",
   "custom t-shirts for group",
   "team t-shirt printing",
   "friends group t-shirt design"
  ]
 },
 {
  "group": "use",
  "slug": "college-fest-tshirts",
  "h1": "College Fest & Batch T-Shirts",
  "title": "College Fest T-Shirt Printing",
  "desc": "Custom t-shirts for college fests, batches, farewells and clubs. Group sizes, quick preview, delivered across India.",
  "intro": "Fests, farewells and batch tees need to look good and arrive on time. Share the design and headcount and we will confirm timelines up front.",
  "points": [
   "Batch, club and committee tees",
   "Farewell and reunion tees with names",
   "Confirm your date when you message us",
   "Bulk pricing on request"
  ],
  "faqs": [
   [
    "Can you deliver before our event date?",
    "Delivery is 5–7 business days after dispatch confirmation. Tell us your event date when ordering so we can plan."
   ],
   [
    "Do you print club or committee logos?",
    "Yes. Send the logo file and we will confirm placement in a preview."
   ]
  ],
  "related": [
   "group-tshirt-printing",
   "event-and-festival-tshirts",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "college fest t-shirts",
   "batch t-shirt printing",
   "farewell t-shirt printing",
   "college club tshirts",
   "committee t-shirt printing"
  ]
 },
 {
  "group": "use",
  "slug": "corporate-team-tshirts",
  "h1": "Corporate & Company T-Shirts",
  "title": "Corporate T-Shirt Printing India",
  "desc": "Branded t-shirts, polos and hoodies for companies and teams. Logo printing or embroidery, bulk orders delivered across India.",
  "intro": "Branded apparel builds team identity and is useful at offsites, launches and client meets. We print or embroider your logo to order.",
  "points": [
   "Printed or embroidered logos",
   "T-shirts, polos and hoodies",
   "Mixed sizes in one order",
   "Bulk pricing on request"
  ],
  "faqs": [
   [
    "Can you match our brand colour?",
    "Share the colour or logo file. We confirm the closest match in the preview."
   ],
   [
    "Do you give invoices for company orders?",
    "Contact us at contact@snera.in with your requirements and billing details."
   ]
  ],
  "related": [
   "polo-tshirt-printing",
   "startup-company-tshirts",
   "embroidered-tshirts"
  ],
  "keywords": [
   "corporate t-shirt printing",
   "company t-shirts with logo",
   "branded t-shirts for employees",
   "office team t-shirts",
   "corporate gifting t-shirts"
  ]
 },
 {
  "group": "use",
  "slug": "wedding-and-bachelor-tshirts",
  "h1": "Wedding, Bridal & Bachelor T-Shirts",
  "title": "Wedding & Bachelor T-Shirts",
  "desc": "Custom t-shirts for brides, grooms and wedding parties. Bride tribe, groom squad and bachelor trip tees printed to order.",
  "intro": "From bride-tribe and groom-squad tees to bachelor trip sets, matching shirts make wedding events more memorable.",
  "points": [
   "Bride tribe, groom squad and family sets",
   "Names or roles on each shirt",
   "Order well before the event date",
   "Preview before printing"
  ],
  "faqs": [
   [
    "How early should I order?",
    "Delivery is 5–7 business days after dispatch, so order a couple of weeks ahead to leave room for changes."
   ],
   [
    "Can each shirt carry a role like \"Bridesmaid\"?",
    "Yes. Share the list of roles, names and sizes."
   ]
  ],
  "related": [
   "group-tshirt-printing",
   "family-matching-tshirts",
   "couple-tshirt-printing"
  ],
  "keywords": [
   "wedding t-shirt printing",
   "bride tribe t-shirts",
   "groom squad t-shirts",
   "bachelor party t-shirts",
   "bridal shower tshirts"
  ]
 },
 {
  "group": "use",
  "slug": "birthday-tshirt-printing",
  "h1": "Birthday T-Shirts & Personalised Gifts",
  "title": "Birthday T-Shirts & Gifts",
  "desc": "Personalised birthday t-shirts and gifts. Add a name, age or photo — printed to order and delivered across India.",
  "intro": "A birthday tee with a name, age or photo makes a gift that feels personal. Share the details and we will send a preview first.",
  "points": [
   "Name, age or photo on the shirt",
   "Matching family or friend sets",
   "Also available as mugs and keychains",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Can I send it directly to the birthday person?",
    "Yes. Enter their address at checkout; we ship to any address in India."
   ],
   [
    "Can I add a photo?",
    "Yes. Full-colour DTG printing works well for photos."
   ]
  ],
  "related": [
   "photo-tshirt-printing",
   "custom-mug-printing",
   "family-matching-tshirts"
  ],
  "keywords": [
   "birthday t-shirt printing",
   "personalised birthday t-shirt",
   "birthday gift t-shirt india",
   "custom birthday tee",
   "birthday squad t-shirts"
  ]
 },
 {
  "group": "use",
  "slug": "gym-and-fitness-tshirts",
  "h1": "Gym & Fitness T-Shirts",
  "title": "Gym & Fitness T-Shirt Printing",
  "desc": "Custom gym t-shirts and tank tops for fitness clubs, trainers and crews. Printed to order and delivered across India.",
  "intro": "Gym crews, trainers and fitness challenges look better in matching gear. Add your gym logo or a motivational line and we will print it.",
  "points": [
   "T-shirts and tank tops",
   "Gym logo or challenge slogan",
   "Order for staff and members together",
   "Bulk pricing on request"
  ],
  "faqs": [
   [
    "Can I print my gym logo for staff and members?",
    "Yes. Send the logo and the sizes and we will confirm the layout."
   ],
   [
    "Which print lasts well with frequent washing?",
    "Screen and DTG prints on 220 GSM cotton are durable; follow the Care Guide for best results."
   ]
  ],
  "related": [
   "custom-tank-top-printing",
   "group-tshirt-printing",
   "screen-printing-tshirts"
  ],
  "keywords": [
   "gym t-shirt printing",
   "fitness club t-shirts",
   "custom gym tank tops",
   "trainer t-shirts with logo",
   "crossfit team t-shirts"
  ]
 },
 {
  "group": "use",
  "slug": "startup-company-tshirts",
  "h1": "Startup & Brand T-Shirts",
  "title": "Startup T-Shirt Printing India",
  "desc": "T-shirts and hoodies for startups and brands. Print your logo on small batches with no minimum order.",
  "intro": "Early-stage teams rarely want to buy hundreds of pieces. Because we print on demand, you can start with a small batch for your team and grow it.",
  "points": [
   "No minimum order for small teams",
   "Logo on chest or back",
   "T-shirts, hoodies and polos",
   "Reorder any time"
  ],
  "faqs": [
   [
    "Can we start with just 10 pieces?",
    "Yes. There is no minimum quantity."
   ],
   [
    "Can we reorder the same design later?",
    "Yes. Send us the same artwork and sizes any time."
   ]
  ],
  "related": [
   "corporate-team-tshirts",
   "custom-hoodie-printing",
   "polo-tshirt-printing"
  ],
  "keywords": [
   "startup t-shirts",
   "brand merchandise t-shirts",
   "merch printing for startups",
   "small batch t-shirt printing",
   "custom brand tees india"
  ]
 },
 {
  "group": "use",
  "slug": "event-and-festival-tshirts",
  "h1": "Event & Festival T-Shirts",
  "title": "Event & Festival T-Shirt Printing",
  "desc": "Custom t-shirts for events, festivals, marathons and fundraisers. Share your date and quantity, printed to order and delivered across India.",
  "intro": "Event tees double as uniforms and souvenirs. Share your event date and quantity and we will plan timelines with you.",
  "points": [
   "Volunteer, staff and attendee tees",
   "Logos and sponsor marks",
   "Tell us your event date upfront",
   "Bulk pricing on request"
  ],
  "faqs": [
   [
    "Can you print sponsor logos?",
    "Yes. Send the logo files and the placement you want."
   ],
   [
    "How do I make sure it arrives in time?",
    "Delivery is 5–7 business days after dispatch. Order early and tell us your event date."
   ]
  ],
  "related": [
   "ngo-and-volunteer-tshirts",
   "bulk-tshirt-printing",
   "custom-tote-bag-printing"
  ],
  "keywords": [
   "event t-shirt printing",
   "festival t-shirts custom",
   "marathon t-shirt printing",
   "fundraiser t-shirts",
   "custom event merchandise india"
  ]
 },
 {
  "group": "use",
  "slug": "trip-and-travel-group-tshirts",
  "h1": "Trip & Travel Group T-Shirts",
  "title": "Trip & Travel Group T-Shirts",
  "desc": "Matching t-shirts for trips, treks and road trips. One design, everyone’s size — printed to order and delivered across India.",
  "intro": "Matching trip tees make group photos instantly better. Pick a design, share sizes and names, and we will print it.",
  "points": [
   "Trip name, year and destination prints",
   "Names or nicknames per person",
   "Delivered before you travel if ordered early",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Can I add the trip date and place?",
    "Yes. Tell us the text and we will lay it out in a preview."
   ],
   [
    "How early should I order?",
    "Allow 5–7 business days after dispatch plus time to approve the preview."
   ]
  ],
  "related": [
   "group-tshirt-printing",
   "family-matching-tshirts",
   "college-fest-tshirts"
  ],
  "keywords": [
   "trip t-shirts group",
   "travel group t-shirt printing",
   "road trip t-shirts custom",
   "trekking group t-shirts",
   "goa trip t-shirts"
  ]
 },
 {
  "group": "use",
  "slug": "family-matching-tshirts",
  "h1": "Family Matching T-Shirts",
  "title": "Family Matching T-Shirts",
  "desc": "Matching family t-shirts for reunions, festivals and photos. All sizes in one order, delivered across India.",
  "intro": "Family reunions, festivals and holiday photos look best with matching tees. Order all sizes together in one design.",
  "points": [
   "Adults and kids in one order",
   "Names, nicknames or family name",
   "Good for reunions and festivals",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Can I order kids sizes?",
    "Share the sizes you need in your order message and we will confirm availability."
   ],
   [
    "Can each person have a different nickname?",
    "Yes. Send the names with sizes."
   ]
  ],
  "related": [
   "group-tshirt-printing",
   "photo-tshirt-printing",
   "birthday-tshirt-printing"
  ],
  "keywords": [
   "family matching t-shirts",
   "family reunion t-shirts",
   "custom family t-shirts india",
   "matching family tees",
   "family trip t-shirts"
  ]
 },
 {
  "group": "use",
  "slug": "school-and-class-tshirts",
  "h1": "School & Class T-Shirts",
  "title": "School & Class T-Shirt Printing",
  "desc": "Custom class, house and school-event t-shirts. Group orders printed to order and delivered across India.",
  "intro": "Class tees, house colours and school-event shirts are easier when printed to order. Share the design and sizes for the whole group.",
  "points": [
   "Class, house and event tees",
   "Names or roll numbers per student",
   "Mixed sizes in one order",
   "Bulk pricing on request"
  ],
  "faqs": [
   [
    "Can I print each student’s name?",
    "Yes. Send the list with sizes."
   ],
   [
    "Can we order for a school event?",
    "Yes. Tell us the date and quantity."
   ]
  ],
  "related": [
   "college-fest-tshirts",
   "group-tshirt-printing",
   "event-and-festival-tshirts"
  ],
  "keywords": [
   "school t-shirt printing",
   "class t-shirts custom",
   "house t-shirts school",
   "farewell class t-shirts",
   "school event t-shirts"
  ]
 },
 {
  "group": "use",
  "slug": "cricket-and-sports-team-tshirts",
  "h1": "Cricket & Sports Team T-Shirts",
  "title": "Sports Team T-Shirt Printing",
  "desc": "Custom t-shirts for cricket, football and sports teams. Team name, player names and numbers, printed to order.",
  "intro": "Local cricket, football and sports teams can get matching tees with the team name and player names or numbers printed on the back.",
  "points": [
   "Team name on front, player name and number on back",
   "Mixed sizes in one order",
   "Good for tournaments and club teams",
   "Bulk pricing on request"
  ],
  "faqs": [
   [
    "Can each player have a different name and number?",
    "Yes. Send the list of names, numbers and sizes."
   ],
   [
    "Which print is best for numbers?",
    "Screen print gives clean, bold numbers and names."
   ]
  ],
  "related": [
   "group-tshirt-printing",
   "screen-printing-tshirts",
   "custom-tank-top-printing"
  ],
  "keywords": [
   "cricket team t-shirts",
   "sports team t-shirt printing",
   "custom jersey style t-shirts",
   "football team tees",
   "tournament t-shirts"
  ]
 },
 {
  "group": "use",
  "slug": "ngo-and-volunteer-tshirts",
  "h1": "NGO & Volunteer T-Shirts",
  "title": "NGO & Volunteer T-Shirts",
  "desc": "Custom t-shirts for NGOs, volunteers and campaigns. Logos and slogans printed to order and delivered across India.",
  "intro": "Volunteer and campaign tees make teams recognisable in the field. We print your logo and message in the quantities you need.",
  "points": [
   "Logo and campaign slogan prints",
   "Order the quantity you need",
   "Reorder as your team grows",
   "Bulk pricing on request"
  ],
  "faqs": [
   [
    "Can I order a small number first?",
    "Yes. There is no minimum order."
   ],
   [
    "Can you print on both sides?",
    "Yes. Tell us the front and back designs."
   ]
  ],
  "related": [
   "event-and-festival-tshirts",
   "bulk-tshirt-printing",
   "group-tshirt-printing"
  ],
  "keywords": [
   "ngo t-shirt printing",
   "volunteer t-shirts custom",
   "campaign t-shirts",
   "charity run t-shirts",
   "awareness t-shirts printing"
  ]
 },
 {
  "group": "use",
  "slug": "couple-tshirt-printing",
  "h1": "Couple T-Shirts — Matching Custom Tees",
  "title": "Couple T-Shirts Custom Printing",
  "desc": "Custom couple t-shirts for anniversaries, trips and gifts. Matching designs and photos, printed to order.",
  "intro": "Matching couple tees are an easy anniversary or trip gift. Choose names, a quote or a photo and we will print a pair.",
  "points": [
   "Matching pair with names, dates or a photo",
   "Great for anniversaries and trips",
   "Both sizes in one order",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Can I order different sizes for each person?",
    "Yes. Share both sizes in the order message."
   ],
   [
    "Can I use a photo of us?",
    "Yes. DTG printing handles photographs well."
   ]
  ],
  "related": [
   "photo-tshirt-printing",
   "wedding-and-bachelor-tshirts",
   "birthday-tshirt-printing"
  ],
  "keywords": [
   "couple t-shirt printing",
   "matching couple t-shirts",
   "anniversary t-shirts custom",
   "custom couple tees india",
   "his and hers t-shirts"
  ]
 },
 {
  "group": "use",
  "slug": "bulk-tshirt-printing",
  "h1": "Bulk T-Shirt Printing in India",
  "title": "Bulk T-Shirt Printing India",
  "desc": "Bulk custom t-shirt printing for events, teams and brands. Mixed sizes, quick preview, delivered across India.",
  "intro": "Ordering for a large group? Send the design, quantity and sizes and we will confirm a preview and price before printing.",
  "points": [
   "Mixed sizes in one order",
   "Consistent print quality across the batch",
   "Preview approved before production",
   "Pricing quoted on request"
  ],
  "faqs": [
   [
    "What is the minimum bulk quantity?",
    "There is no minimum. Send your quantity and we will quote."
   ],
   [
    "How do I get a bulk price?",
    "Message us on WhatsApp or email contact@snera.in with the design, quantity and sizes."
   ]
  ],
  "related": [
   "group-tshirt-printing",
   "corporate-team-tshirts",
   "event-and-festival-tshirts"
  ],
  "keywords": [
   "bulk t-shirt printing",
   "wholesale custom t-shirts india",
   "bulk custom tshirt order",
   "t-shirt printing in bulk",
   "bulk printed tees"
  ]
 },
 {
  "group": "use",
  "slug": "single-piece-custom-tshirt",
  "h1": "Single-Piece Custom T-Shirt — No Minimum Order",
  "title": "Single Custom T-Shirt, No Minimum",
  "desc": "Order just one custom t-shirt. No minimum order, printed on 220 GSM cotton and delivered across India.",
  "intro": "You do not need to order a dozen to get a custom tee. Because everything is printed on demand, one piece is a normal order for us.",
  "points": [
   "No minimum order quantity",
   "Same quality as bulk",
   "Great for gifts and trying a design",
   "Preview before printing"
  ],
  "faqs": [
   [
    "Is there really no minimum?",
    "Correct. You can order a single custom t-shirt."
   ],
   [
    "Is a single piece more expensive?",
    "Prices are shown per piece in the shop; contact us for custom quotes."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "custom-tshirt-printing",
   "birthday-tshirt-printing"
  ],
  "keywords": [
   "single custom t-shirt",
   "custom t-shirt no minimum order",
   "1 piece t-shirt printing",
   "low moq t-shirt printing",
   "order one custom tee"
  ]
 },
 {
  "group": "method",
  "slug": "dtg-tshirt-printing",
  "h1": "DTG T-Shirt Printing (Direct-to-Garment)",
  "title": "DTG T-Shirt Printing India",
  "desc": "Direct-to-garment printing for detailed, full-colour t-shirt designs. Ideal for photos and small orders, delivered across India.",
  "intro": "DTG prints your artwork straight onto the fabric like an inkjet printer. It reproduces gradients, photos and many colours, and suits single pieces and small batches.",
  "points": [
   "Full-colour detail and gradients",
   "Works for single pieces",
   "Best for photos and illustrations",
   "Soft print feel on cotton"
  ],
  "faqs": [
   [
    "When should I choose DTG?",
    "For photos, detailed illustrations or designs with many colours, especially in small quantities."
   ],
   [
    "When is screen print better?",
    "For bold, few-colour designs in larger quantities."
   ]
  ],
  "related": [
   "photo-tshirt-printing",
   "screen-printing-tshirts",
   "custom-tshirt-printing"
  ],
  "keywords": [
   "dtg t-shirt printing",
   "direct to garment printing india",
   "dtg printing online",
   "dtg vs screen printing",
   "digital t-shirt printing"
  ]
 },
 {
  "group": "method",
  "slug": "screen-printing-tshirts",
  "h1": "Screen Printing T-Shirts",
  "title": "Screen Printing T-Shirts India",
  "desc": "High-density screen printing for bold, durable t-shirt designs. Best for logos, text and group orders.",
  "intro": "Screen printing pushes ink through a stencil for solid, vivid, durable colour. It is the pick for logos, slogans and larger group orders.",
  "points": [
   "Bold, solid colour",
   "Durable for frequent washing",
   "Best for logos and text",
   "Cost-effective for group orders"
  ],
  "faqs": [
   [
    "Is screen print good for photos?",
    "DTG is better for photos. Screen print suits bold, few-colour designs."
   ],
   [
    "Is it durable?",
    "Yes. Follow the Care Guide for best results."
   ]
  ],
  "related": [
   "dtg-tshirt-printing",
   "group-tshirt-printing",
   "name-and-text-tshirt-printing"
  ],
  "keywords": [
   "screen printing t-shirts",
   "screen print t-shirt india",
   "silk screen printing tshirt",
   "high density print t-shirt",
   "screen printed tees"
  ]
 },
 {
  "group": "method",
  "slug": "puff-print-tshirts",
  "h1": "Puff Print T-Shirts (3D Raised Print)",
  "title": "Puff Print T-Shirts India",
  "desc": "Raised 3D puff print on custom t-shirts. Textured lettering and graphics, printed to order in India.",
  "intro": "Puff print expands when heated to create a raised, textured finish that stands out on streetwear and statement graphics.",
  "points": [
   "Raised, tactile 3D finish",
   "Ideal for chunky lettering and logos",
   "Popular on oversized and drop shoulder tees",
   "Preview before printing"
  ],
  "faqs": [
   [
    "What designs suit puff print?",
    "Bold shapes and lettering. Very fine detail is better suited to DTG."
   ],
   [
    "Can I combine puff with a normal print?",
    "Tell us your design and we will advise in the preview."
   ]
  ],
  "related": [
   "oversized-tshirt-printing",
   "drop-shoulder-tshirt-printing",
   "screen-printing-tshirts"
  ],
  "keywords": [
   "puff print t-shirt",
   "3d puff print tshirt india",
   "raised print t-shirt",
   "puff printing custom",
   "puff print hoodie"
  ]
 },
 {
  "group": "method",
  "slug": "embroidered-tshirts",
  "h1": "Embroidered T-Shirts & Polos",
  "title": "Embroidered T-Shirts India",
  "desc": "Custom embroidery on t-shirts, polos and hoodies. Premium stitched logos for teams and brands.",
  "intro": "Stitched logos give a premium, long-lasting finish, especially on polos and hoodies. Send your logo and we will confirm size and placement.",
  "points": [
   "Left-chest logo embroidery",
   "Premium finish for teams and brands",
   "Works on polos, tees and hoodies",
   "Preview before production"
  ],
  "faqs": [
   [
    "What logo files do you need?",
    "A clear, high-resolution logo. Tell us the colours and placement."
   ],
   [
    "Is embroidery suitable for photos?",
    "No. Embroidery suits logos and simple shapes."
   ]
  ],
  "related": [
   "polo-tshirt-printing",
   "corporate-team-tshirts",
   "custom-hoodie-printing"
  ],
  "keywords": [
   "embroidered t-shirts",
   "custom embroidery t-shirt india",
   "logo embroidery polo",
   "embroidered hoodie",
   "embroidery on tshirt"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-indore",
  "h1": "Custom T-Shirt Printing for Indore",
  "title": "Custom T-Shirt Printing Indore",
  "desc": "Order custom printed t-shirts online for delivery in Indore. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Indore. Indore’s colleges, coaching batches, startups and families can order one tee or a full batch — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Indore in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Indore?",
    "Yes. We ship across India, including Indore. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Indore?",
    "SNERA is an online studio and does not run a physical store in Indore. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing indore",
   "t-shirt printing in indore",
   "custom t shirts indore",
   "online t-shirt printing indore",
   "bulk t-shirt printing indore"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-mumbai",
  "h1": "Custom T-Shirt Printing for Mumbai",
  "title": "Custom T-Shirt Printing Mumbai",
  "desc": "Order custom printed t-shirts online for delivery in Mumbai. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Mumbai. Mumbai’s event crews, college fests and startups can order small or large batches — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Mumbai in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Mumbai?",
    "Yes. We ship across India, including Mumbai. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Mumbai?",
    "SNERA is an online studio and does not run a physical store in Mumbai. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing mumbai",
   "t-shirt printing in mumbai",
   "custom t shirts mumbai",
   "online t-shirt printing mumbai",
   "bulk t-shirt printing mumbai"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-delhi",
  "h1": "Custom T-Shirt Printing for Delhi",
  "title": "Custom T-Shirt Printing Delhi",
  "desc": "Order custom printed t-shirts online for delivery in Delhi. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Delhi. Delhi’s college societies, offices and event teams can order tees for the whole group — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Delhi in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Delhi?",
    "Yes. We ship across India, including Delhi. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Delhi?",
    "SNERA is an online studio and does not run a physical store in Delhi. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing delhi",
   "t-shirt printing in delhi",
   "custom t shirts delhi",
   "online t-shirt printing delhi",
   "bulk t-shirt printing delhi"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-bengaluru",
  "h1": "Custom T-Shirt Printing for Bengaluru",
  "title": "Custom T-Shirt Printing Bengaluru",
  "desc": "Order custom printed t-shirts online for delivery in Bengaluru. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Bengaluru. Bengaluru’s tech teams, startups and meetup groups can order brand tees in small batches — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Bengaluru in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Bengaluru?",
    "Yes. We ship across India, including Bengaluru. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Bengaluru?",
    "SNERA is an online studio and does not run a physical store in Bengaluru. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing bengaluru",
   "t-shirt printing in bengaluru",
   "custom t shirts bengaluru",
   "online t-shirt printing bengaluru",
   "bulk t-shirt printing bengaluru"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-pune",
  "h1": "Custom T-Shirt Printing for Pune",
  "title": "Custom T-Shirt Printing Pune",
  "desc": "Order custom printed t-shirts online for delivery in Pune. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Pune. Pune’s colleges, clubs and companies can order matching tees for the whole group — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Pune in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Pune?",
    "Yes. We ship across India, including Pune. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Pune?",
    "SNERA is an online studio and does not run a physical store in Pune. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing pune",
   "t-shirt printing in pune",
   "custom t shirts pune",
   "online t-shirt printing pune",
   "bulk t-shirt printing pune"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-hyderabad",
  "h1": "Custom T-Shirt Printing for Hyderabad",
  "title": "Custom T-Shirt Printing Hyderabad",
  "desc": "Order custom printed t-shirts online for delivery in Hyderabad. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Hyderabad. Hyderabad’s teams, events and student groups can order custom tees on demand — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Hyderabad in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Hyderabad?",
    "Yes. We ship across India, including Hyderabad. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Hyderabad?",
    "SNERA is an online studio and does not run a physical store in Hyderabad. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing hyderabad",
   "t-shirt printing in hyderabad",
   "custom t shirts hyderabad",
   "online t-shirt printing hyderabad",
   "bulk t-shirt printing hyderabad"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-chennai",
  "h1": "Custom T-Shirt Printing for Chennai",
  "title": "Custom T-Shirt Printing Chennai",
  "desc": "Order custom printed t-shirts online for delivery in Chennai. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Chennai. Chennai’s clubs, colleges and families can order custom tees and gifts online — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Chennai in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Chennai?",
    "Yes. We ship across India, including Chennai. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Chennai?",
    "SNERA is an online studio and does not run a physical store in Chennai. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing chennai",
   "t-shirt printing in chennai",
   "custom t shirts chennai",
   "online t-shirt printing chennai",
   "bulk t-shirt printing chennai"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-kolkata",
  "h1": "Custom T-Shirt Printing for Kolkata",
  "title": "Custom T-Shirt Printing Kolkata",
  "desc": "Order custom printed t-shirts online for delivery in Kolkata. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Kolkata. Kolkata’s festival committees, clubs and colleges can order group tees online — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Kolkata in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Kolkata?",
    "Yes. We ship across India, including Kolkata. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Kolkata?",
    "SNERA is an online studio and does not run a physical store in Kolkata. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing kolkata",
   "t-shirt printing in kolkata",
   "custom t shirts kolkata",
   "online t-shirt printing kolkata",
   "bulk t-shirt printing kolkata"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-ahmedabad",
  "h1": "Custom T-Shirt Printing for Ahmedabad",
  "title": "Custom T-Shirt Printing Ahmedabad",
  "desc": "Order custom printed t-shirts online for delivery in Ahmedabad. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Ahmedabad. Ahmedabad’s businesses, garba groups and colleges can order custom tees online — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Ahmedabad in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Ahmedabad?",
    "Yes. We ship across India, including Ahmedabad. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Ahmedabad?",
    "SNERA is an online studio and does not run a physical store in Ahmedabad. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing ahmedabad",
   "t-shirt printing in ahmedabad",
   "custom t shirts ahmedabad",
   "online t-shirt printing ahmedabad",
   "bulk t-shirt printing ahmedabad"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-jaipur",
  "h1": "Custom T-Shirt Printing for Jaipur",
  "title": "Custom T-Shirt Printing Jaipur",
  "desc": "Order custom printed t-shirts online for delivery in Jaipur. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Jaipur. Jaipur’s wedding parties, events and brands can order custom tees online — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Jaipur in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Jaipur?",
    "Yes. We ship across India, including Jaipur. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Jaipur?",
    "SNERA is an online studio and does not run a physical store in Jaipur. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing jaipur",
   "t-shirt printing in jaipur",
   "custom t shirts jaipur",
   "online t-shirt printing jaipur",
   "bulk t-shirt printing jaipur"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-lucknow",
  "h1": "Custom T-Shirt Printing for Lucknow",
  "title": "Custom T-Shirt Printing Lucknow",
  "desc": "Order custom printed t-shirts online for delivery in Lucknow. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Lucknow. Lucknow’s colleges, clubs and families can order custom tees online — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Lucknow in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Lucknow?",
    "Yes. We ship across India, including Lucknow. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Lucknow?",
    "SNERA is an online studio and does not run a physical store in Lucknow. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing lucknow",
   "t-shirt printing in lucknow",
   "custom t shirts lucknow",
   "online t-shirt printing lucknow",
   "bulk t-shirt printing lucknow"
  ]
 },
 {
  "group": "city",
  "slug": "custom-tshirt-printing-bhopal",
  "h1": "Custom T-Shirt Printing for Bhopal",
  "title": "Custom T-Shirt Printing Bhopal",
  "desc": "Order custom printed t-shirts online for delivery in Bhopal. No minimum order, 220 GSM cotton, 5–7 business days delivery.",
  "intro": "SNERA is an online custom t-shirt studio that prints on demand and delivers across India, including Bhopal. Bhopal’s colleges, teams and event groups can order custom tees online — printed on 220 GSM cotton and delivered to your door.",
  "points": [
   "Delivered to Bhopal in 5–7 business days",
   "No minimum order — one piece or a full batch",
   "Digital preview on WhatsApp before printing",
   "Free shipping above ₹999"
  ],
  "faqs": [
   [
    "Do you deliver custom t-shirts to Bhopal?",
    "Yes. We ship across India, including Bhopal. Delivery takes 5–7 business days after dispatch."
   ],
   [
    "Do you have a store in Bhopal?",
    "SNERA is an online studio and does not run a physical store in Bhopal. You order online and we deliver to your address."
   ]
  ],
  "related": [
   "on-demand-tshirt-printing",
   "group-tshirt-printing",
   "bulk-tshirt-printing"
  ],
  "keywords": [
   "custom t-shirt printing bhopal",
   "t-shirt printing in bhopal",
   "custom t shirts bhopal",
   "online t-shirt printing bhopal",
   "bulk t-shirt printing bhopal"
  ]
 }
];